import React from 'react'

import PropTypes from 'prop-types'

import find from 'lodash/find'
import isEmpty from 'lodash/isEmpty'
import map from 'lodash/map'

import I18n from '@galo-monitor/i18n'

import Functionality from './Functionality'

const ModuleFunctionalities = (props) => {
  const { functionalities, permissions, setPermissions, isLoading } = props
  return (
    <>
      {!functionalities ? (
        <I18n>loading</I18n>
      ) : (
        <>
          {isEmpty(functionalities) ? (
            <I18n>empty select options</I18n>
          ) : map(functionalities, functionality => (
            <Functionality
              key={ functionality.slug }
              functionality={ functionality }
              disabled={ isLoading }
              defaultPermissions={ find(permissions, perm => perm.slug === functionality.slug) }
              onChangePermissions={ setPermissions }
            />
          ))}
        </>
      )}
    </>
  )
}

ModuleFunctionalities.propTypes = {
  functionalities: PropTypes.array.isRequired,
  permissions: PropTypes.array.isRequired,
  setPermissions: PropTypes.func.isRequired,
  isLoading: PropTypes.bool
}

ModuleFunctionalities.defaultProps = {
  isLoading: false
}

export default ModuleFunctionalities
